import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '../features/authSlice';

export const Store = configureStore({
    reducer: {  auth: authReducer },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type appDispatch = typeof Store.dispatch;
export type RootState = ReturnType<typeof Store.getState>;

setupListeners(Store.dispatch);
